<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs row">
                        <div class="col-xs-12 col-sm-fill hidden-xs">
                            <h3>
                                <i class="las" :class="$router.currentRoute.meta.icon"></i>
                                {{$router.currentRoute.meta.title}}
                            </h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xl-12">
                            <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">

                                <div class="row">
                                    <div class="col-md-6 col-lg-5 col-xl-4">
                                        <div class="submit-field">
                                            <h5>Nome da equipe:</h5>
                                            <input type="text" class="with-border" placeholder="Informe o nome..." required=""  v-model="form.nome">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-12">
                                        <h4>
                                            Seleciones os técnicos:
                                        </h4>
                                    </div>
                                    <div class="col-xs-12 col-xl-9">
                                        <div class="parent table-scroll margin-top-10" style="overflow-x: auto !important; border: 1px solid #ddd;">
                                            <table class="child table table-bordered table-bordered-default">
                                                <thead>
                                                    <th style="min-width: 50px; width: 50px; text-align: center;">
                                                        #
                                                    </th>
                                                    <th style="min-width: 160px;">
                                                        Nome
                                                    </th>
                                                    <th style="min-width: 260px; width: 260px;">
                                                        E-mail
                                                    </th>
                                                    <th style="min-width: 120px; width: 120px; text-align: center;">
                                                        Telefone
                                                    </th>
                                                </thead>
                                                <tbody>   
                                                    <tr v-for="(item, index) in usuarios.itens">
                                                        <td data-label="#" style="text-align: center; width: 60px;">
                                                            <div class="checkbox">
                                                                <input style=" border: 0px !important" name="checkbox" v-model="form.usuarios" :value="item.cod" :id="'check' + index " type="checkbox">
                                                                <label :for="'check' + index"><span class="checkbox-icon"></span></label>
                                                            </div>
                                                        </td>
                                                        <td data-label="Nome:" style="">
                                                            <label :for="'check' + index">
                                                                {{item.nome}}
                                                            </label>
                                                        </td>   
                                                        <td data-label="E-mail:">
                                                            <label :for="'check' + index">
                                                                {{item.email}}
                                                            </label>
                                                        </td>
                                                        <td data-label="Telefone:" style="text-align: center;">
                                                            <a>
                                                                {{item.telefone}}
                                                            </a>
                                                        </td>           
                                                    </tr> 
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="col-xl-12 margin-top-30 margin-bottom-30">
                                        <button type="submit" v-if="form.ativo == 1 || !form.cod" class="button color-green block-mobile" v-bind:class="{'disabled': loading.submit }">
                                            <i class="las la-save"></i>
                                            Salvar equipe
                                        </button>
                                        <button v-if="form.cod && form.ativo == 1" type="button" v-on:click="del(form.cod)" class="button outline-gray block-mobile">
                                            <i class="las la-ban"></i>
                                            Excluir equipe
                                        </button>                                                
                                    </div>
                                </div>
                            </form>
                        </div> 
                    </div>                

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'
import AvatarCropper from "vue-avatar-cropper"

export default {
    name: 'GerenciarEquipes',
    components: {
        'AvatarCropper': AvatarCropper,
        'Top':      Top,
        'Sidebar':  Sidebar,
        'Toolbar':  Toolbar
    },          
    data () {
        var self                    = this;
        return {
            "salvo":        false,
            "loading": {
                "submit":           false
            },
            "usuarios": {
                "itens":            [
                ]
            },            
            "form": {
                "_cod":             "",
                "_token":           "",
                "nome":             "",
                "usuarios":         [],            
            }            
        }
    },
    methods: { 
        submit: function(e) {
            var self            = this;
            self.form._cod      = self.$root.user.cod;
            self.form._token    = self.$root.user.token;
            console.log("submit()", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
                
            var a = "post";
            if (self.form.cod) {
                a = "put";
            }

            console.log("acao", a);

            axios[a]("api/equipes.php", self.form)
            .then(response => {
                
                self.loading.submit = false;
                self.salvo          = true;
                console.log("submit() response", response)
                loading.hide();
                alert(response.data.message);
                self.$root.back();
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        getUsuarios: function() {
            var self        = this;
            console.log("getUsuarios()");
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "tipo":         "prestador",
                        "page":         1
                    }
                };

                axios.get("api/usuarios.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.usuarios       = response.data.result;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          self.form.cod
                    }
                };

                axios.get("api/equipes.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.form           = response.data.result;
                    self.loaded         = true;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },
        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar?", function() {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          cod
                    }
                };
                loading.show();
                
                axios.delete("api/equipes.php", form)
                .then(response => {
                    console.log("del() response", response)
                    self.salvo          = true;
                    self.$root.back();
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        }               
    },    
    created: function() {
        var self = this;
        console.log("created", self);

        if (self.$route.name == "EditarEquipes") {
            if (!self.$route.query.c) {
                self.$root.back();
                return false;
            }
            loading.show();
            self.form.cod = self.$route.query.c;
            self.get();
            self.getUsuarios();
        } else {
            
            self.getUsuarios();
        }
    },
    activated: function() {
        var self = this;

    },
    beforeRouteLeave (to, from, next) {
        var self = this;
        if (!self.salvo) {
            const answer = window.confirmWeb('Você tem certeza que deseja sair da página atual? Modificações não salvas podem ser perdidas.')
            if (!answer) return false;
        }
        next();
    }      
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .card .dashboard-status-button {
        margin-top: 8px;
    }

    .uploadButton-button {
        display: none !important;
    }        
    .button.gray.block-mobile {
        font-weight: 400;
        border: 1px solid #ddd !important;
    }

    .imagem-preview {
        width: 100%;
        height: 35vh;
        border-radius: 10px;
        margin-bottom: 25px !important;
        background-size: contain;
        background-color: #ddd;
        background-position: center;
        background-repeat: no-repeat;
    }    

    .uploadButton .uploadButton-input {
        opacity: 0 !important;
    }

    td label {
        margin-bottom: 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/GerenciarEquipes.vue